import { Link, useNavigate, useLocation } from 'react-router-dom';
import { getToken, removeToken } from '../utils/auth';
import { useEffect, useState, useRef } from 'react';
import api from '../api/axios';

export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuAbierto, setMenuAbierto] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const navRef = useRef(null);
  const [linksAtBottom, setLinksAtBottom] = useState(false);

  useEffect(() => {
    setIsLoggedIn(!!getToken());
  }, [location]);
  // Detecta el scroll en el listado de links para ocultar/mostrar el degradado
  useEffect(() => {
    const el = navRef.current;
    if (!el) {
      setLinksAtBottom(true);
      return;
    }

    const check = () => {
      const atBottom = Math.abs(el.scrollHeight - el.scrollTop - el.clientHeight) <= 1;
      setLinksAtBottom(atBottom);
    };

    const onResize = () => check();

    el.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', onResize);
    // comprobar inicialmente y justo después de abrir (permite layout)
    check();
    if (menuAbierto) setTimeout(check, 60);

    return () => {
      el.removeEventListener('scroll', check);
      window.removeEventListener('resize', onResize);
    };
  }, [menuAbierto]);

  // Comprueba si el usuario es admin para mostrar enlaces en el menú lateral
  useEffect(() => {
    const token = getToken();
    const telefonoGuardado = localStorage.getItem('telefono');
    if (!token || !telefonoGuardado) return;

    (async () => {
      try {
        const res = await api.post('/auth/check-rol', { telefono: telefonoGuardado }, { headers: { Authorization: `Bearer ${token}` } });
        setIsAdmin(res.data.rol === 'admin');
      } catch (err) {
        setIsAdmin(false);
      }
    })();
  }, [location]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleLogout = () => {
    removeToken();
    localStorage.removeItem('telefono');
    setIsLoggedIn(false);
    navigate('/');
  };

  const isHome = location.pathname === '/';
  const headerClass = `${isHome ? 'header-inicio' : 'header'}${isScrolled ? ' scrolled' : ''}`;

  const isActive = (path) => location.pathname === path;

  return (
    <>
      <header className={headerClass}>
        <div className="grid-header">
          <Link to="/" className="logo-link">
            <img src="/images/logomujica_negro.svg" alt="Logo Barber Mujica" />
          </Link>

          <nav className="header-menu">
            <Link to="/" className={isActive('/') ? 'activo' : ''}>Inicio</Link>
            <Link to="/sobre-mi" className={isActive('/sobre-mi') ? 'activo' : ''}>Sobre mí</Link>
            <Link to="/reservar" className={isActive('/reservar') ? 'activo' : ''}>Reservar</Link>

            {isLoggedIn ? (
              <div className="user-actions-header">
                <Link className="dashboard-button" to="/dashboard">Dashboard</Link>
                <button className="logout-button" onClick={handleLogout}>Cerrar sesión</button>
              </div>
            ) : (
              <div className="user-actions-header">
                <Link className="login-button" to="/login">Iniciar sesión</Link>
                <Link className="register-button" to="/register">Registrarse</Link>
              </div>
            )}
          </nav>
          <div className="responsive-actions">
            <div className="responsive-actions-grid">
              <Link className='reserva-responsive' to="/reservar">
                <img src="/images/reserva.svg" alt="Icono" />
              </Link>
              <Link className='login-responsive' to="/dashboard">
                <img src="/images/login.svg" alt="Icono" />
                {isLoggedIn ? <p>Mi perfil</p> : <p>Iniciar sesión</p>}
              </Link>
            </div>
            <div className="burger">
              <label htmlFor="burger-menu" className="burger-button">
                <input
                  type="checkbox"
                  id="burger-menu"
                  checked={menuAbierto}
                  onChange={(e) => setMenuAbierto(e.target.checked)}
                />
                <span className="burger-icon"></span>
                <span className="burger-icon"></span>
              </label>
            </div>
          </div>

        </div>
      </header>

      {/* Menú lateral móvil */}
      <div className={`menu-lateral ${menuAbierto ? 'menu-activo' : ''}`}>
        <div className="menu-lateral-grid">
          <a className="logo-link" href="/"><img alt="Logo Barber Mujica" src="/images/logomujica_negro.svg"/></a>
          <div className={`menu-lateral-links-wrapper ${linksAtBottom ? 'at-bottom' : ''}`}>
            <nav ref={navRef} className="menu-lateral-links">
            <Link to="/" onClick={() => setMenuAbierto(false)}>Inicio</Link>
            <Link to="/sobre-mi" onClick={() => setMenuAbierto(false)}>Sobre mí</Link>
            <Link to="/reservar" onClick={() => setMenuAbierto(false)}>Reservar</Link>
            {isAdmin && (
              <>
                <Link to="/dashboard/calendario" onClick={() => setMenuAbierto(false)}>Calendario de citas</Link>
                <Link to="/dashboard/asistencias" onClick={() => setMenuAbierto(false)}>Asistencias</Link>
                <Link to="/dashboard/servicios" onClick={() => setMenuAbierto(false)}>Servicios</Link>
                <Link to="/dashboard/clientes" onClick={() => setMenuAbierto(false)}>Clientes</Link>
                <Link to="/dashboard/bloqueados" onClick={() => setMenuAbierto(false)}>Bloqueados</Link>
                <Link to="/dashboard/finanzas" onClick={() => setMenuAbierto(false)}>Finanzas</Link>
                <Link to="/dashboard/horario-de-trabajo" onClick={() => setMenuAbierto(false)}>Horario de trabajo</Link>
                <Link to="/dashboard/dias-especiales" onClick={() => setMenuAbierto(false)}>Días especiales</Link>
                <Link to="/dashboard/ajustes-del-sistema" onClick={() => setMenuAbierto(false)}>Ajustes del sistema</Link>
              </>
            )}
            </nav>
          </div>
          <div className="menu-lateral-actions">
              {isLoggedIn ? (
                <>
                {!isAdmin && (
                  <Link to="/dashboard" onClick={() => setMenuAbierto(false)}>Mis citas</Link>
                ) }
                  <button onClick={() => { handleLogout(); setMenuAbierto(false); }}>Cerrar sesión</button>
                </>
              ) : (
                <>
                  <Link to="/login" onClick={() => setMenuAbierto(false)}>Iniciar sesión</Link>
                  <Link to="/register" onClick={() => setMenuAbierto(false)}>Registrarse</Link>
                </>
              )}    
            </div>
            <div className='copyright-menu'>
              <p>© Barberfy. Facilitando la reserva de citas online en el sector de la belleza.</p>
            </div>
          </div>

      </div>
    </>
  );
}
